import { Configuration } from "../environment/setup";
class Constant {
  public readonly DEFAULT = "/";
  public readonly HOME = "/home";
  public readonly ACTIVITIES = "/activities";

  public readonly CONTENTS = "/content-areas";
  public readonly ADDCONTENT = "/content-areas/new";
  public readonly EDITCONTENT = "/content-areas/edit/:id";

  public readonly SUBJECTS = "/subjects";
  public readonly ADDSUBJECT = "/subjects/new";
  public readonly SUBJECTDETAIL = "/subjects/edit/:id";

  public readonly DOMAINS = "/domains";
  public readonly ADDDOMAIN = "/domains/new";
  public readonly EDITDOMAIN = "/domains/edit/:id";

  public readonly STANDARDS = "/standards";
  public readonly ADDSTANDARD = "/standards/new";
  public readonly EDITSTANDARD = "/standards/edit/:id";
  public readonly STANDARDS_MAGIC_MATCH = "/standards/magic-match";

  public readonly STANDARDLINK = "/standard-linking";

  public readonly QUESTION = "/questions";
  public readonly MANAGEQUESTION = "/questions/edit/:id";
  public readonly AUTHORQUESTION = "/questions/new";
  public readonly PUBLIC_ITEM_PREVIEW = "/public/item-preview/:id";

  public readonly TEACHER_QUESTION_LIST = "/teacher-questions";

  public readonly PASSAGE = "/passages";
  public readonly ADDPASSAGE = "/passages/new";
  public readonly EDITPASSAGE = "/passages/edit/:id";
  public readonly PASSAGEQUESTIONS = "/passage-questions";

  public readonly GRADES = "/grades";
  public readonly ADDGRADE = "/grades/new";
  public readonly EDITGRADE = "/grades/edit/:id";

  public readonly TAGS = "/tags";
  public readonly ADDTAG = "/tags/new";
  public readonly EDITTAG = "/tags/edit/:id";

  public readonly WORKSHEETS = "/worksheets";
  public readonly ADDWORKSHEET = "/worksheets/new";
  public readonly WORKSHEETEDIT = "/worksheets/edit/:id";

  public readonly SLIDES = "/slides";
  public readonly ADDSLIDE = "/slides/new";
  public readonly SLIDEEDIT = "/slides/edit/:id";
  public readonly SLIDE_STANDARDS = "/slide-standards/:slideId";

  public readonly VIDEOS = "/videos";
  public readonly VIDEO = "/videos/new";
  public readonly VIDEOEDIT = "/videos/edit/:id";

  public readonly LESSONPLANS = "/lesson-plans";
  public readonly LESSONPLANS_NEW = "/lesson-plans/new";
  public readonly LESSONPLANS_EDIT = "/lesson-plans/:lessonPlanId";
  public readonly LESSONPLANS_ASSETS_NEW =
    "/lesson-plans/:lessonPlanId/assets/new";
  public readonly LESSONPLANS_ASSETS_EDIT =
    "/lesson-plans/:lessonPlanId/assets/:lessonPlanAssetId";

  public readonly LEARNOSITY_UTILS_RESUBMIT = "/learnosity-utils/resubmit";

  public readonly DEFAULT_SUBJECTS = "/defaultSubjects";

  public readonly SKILLS = "/skills";

  public readonly SKILLPRACTICESUBJECT = "/skill-subjects";
  public readonly ADDSKILLSUBJECT = "/skill-subjects/new";
  public readonly MANAGESKILLSUBJECT = "/skill-subjects/edit/:id";

  public readonly SKILLPRACTICESTANDARD = "/skill-standards";
  public readonly ADDSKILLSTANDARD = "/skill-standards/new";
  public readonly MANAGESKILLSTANDARD = "/skill-standards/edit/:id";

  public readonly SKILLPRACTICEQUESTION = "/skill-questions";
  public readonly ADDSKILLQUESTION = "/skill-questions/new";
  public readonly MANAGESKILLQUESTION = "/skill-questions/edit/:id";

  public readonly CANNEDTESTALL = "/canned-tests";
  public readonly CANNEDTEST = "/canned-tests/new";
  public readonly CANNEDTESTDETAIL = "/canned-tests/edit/:cannedtestId";
  public readonly CANNEDTESTIMPORT = "/canned-tests/import";
  public readonly CANNEDTESTDETAILIMPORT = "/canned-tests/import/:cannedtestId";
  public readonly CANNEDTESTCREATE = "/cannedtestcreate";

  public readonly PRICING = "/pricing";
  public readonly SELLABLEPRODUCT = "/sellable-products";
  public readonly ADDSELLABLEPRODUCT = "/sellable-products/new";
  public readonly MANAGESELLABLEPRODUCT = "/sellable-products/edit/:id";

  public readonly BUNDLES = "/bundles";
  public readonly ADDBUNDLES = "/bundles/new";
  public readonly EDITBUNDLES = "/bundles/edit/:id";

  public readonly DASHBOARD = "/dashboard";
  public readonly MASTER = "/master";
  public readonly LIFTOFF = "/liftoff";
  public readonly LIFTOFFHEADER = "/liftoffheader";
  public readonly LIFTOFFSUBJECT = "/liftoffsubject";
  public readonly LIFTOFFSUBJECTEDIT = "/liftoffsubject/:subjectId";
  public readonly SKILLPRACTICE = "/skillspractice";

  public readonly STANDARDGROUPS = "/standard-groups";
  public readonly STANDARDGROUPEDIT = "/standard-groups/:id";

  public readonly SCHOOLDETAIL = "/school-detail/:id";
  public readonly DISTRICTDETAIL = "/district-detail/:id";

  public readonly BAD_REQUEST = "/bad-request";

  public readonly ManageAction = {
    ADD: "ADD",
    EDIT: "EDIT",
  };
  public readonly STRANDS = "/strand";
  public readonly IMAGEGALLERY = "/image-gallery";
  public readonly StandardLinkingType = {
    ONEWAY: "OneWay",
    TWOWAY: "TwoWay",
  };

  public readonly PERMISSIONS = "/administration/permissions";
  public readonly ADD_PERMISSION = "/administration/permission/new";
  public readonly EDIT_PERMISSION = "/administration/permission/edit/:id";
  public readonly PERMISSION_GROUPS = "/administration/permission-groups";
  public readonly ADD_PERMISSION_GROUP = "/administration/permission-group/new";
  public readonly EDIT_PERMISSION_GROUP =
    "/administration/permission-group/edit/:id";
  public readonly USER_PERMISSIONS = "/administration/user-permissions";
  public readonly ADD_USER_PERMISSION = "/administration/user-permission/new";
  public readonly EDIT_USER_PERMISSION =
    "/administration/user-permission/edit/:id";
  public readonly CRM = "/crm";
  public readonly Utilities = "/utilities";
  public readonly ClassifyCleanup = "/classifycleanup";
  public readonly crmAddUser = "/crm/user/new";
  public readonly crmAddSchool = "/crm/school/new";
  public readonly crmAddDistrict = "/crm/district/new";
  public readonly crmUserContent = "/crm/users/:userid/content";
  public readonly crmUserContentPassages =
    "/crm/users/:userid/content/passages";
  public readonly crmUserContentPassageEdit =
    "/crm/users/:userid/content/passages/:teacherPassageId";
  public readonly crmUserContentQuestions =
    "/crm/users/:userid/content/questions";
  public readonly crmUserContentQuestionCreate =
    "/crm/users/:userid/content/questions/new";
  public readonly crmUserContentQuestionEdit =
    "/crm/users/:userid/content/questions/:teacherQuestionId";
  public readonly crmUserContentAssessments =
    "/crm/users/:userid/content/assessments";
  public readonly crmUserContentAssessmentCreate =
    "/crm/users/:userid/content/assessments/new";
  public readonly crmUserContentAssessmentEdit =
    "/crm/users/:userid/content/assessments/:assessmentId";
  public readonly crmUserContentAssessmentBank =
    "/crm/users/:userid/content/assessments/bank";
  public readonly crmUserContentAssessmentBuilder =
    "/crm/users/:userid/content/assessments/builder";

  public readonly LIFTOFFGALAXIES = {
    GALAXY1: 1,
    GALAXY2: 2,
    GALAXY3: 3,
    GALAXY4: 4,
    GALAXY5: 5,
    GALAXY6: 6,
    GALAXY7: 7,
    GALAXY8: 8,
  };

  public readonly VIDEO_ASSOCIATED_QUESTIONS = "/video-associate-questions";
  public readonly SubjectType = {
    PL: 1,
    LO: 2,
    CCR: 3,
  };
  public readonly ENGLISH = 1;
  public readonly SPANISH = 2;

  public readonly URL_VALIDATOR_EXPRESSION =
    "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?";

  public readonly ASSOCIATED_QUESTIONS = "/associate-questions";
  public readonly LANGUAGE = {
    English: 1,
    Spanish: 2,
  };
  public readonly SUPERSHEETS = "/supersheets";
  public readonly ADDSUPERSHEET = "/supersheets/new";
  public readonly EDITSUPERSHEET = "/supersheets/edit/:id";
  public readonly PRODUCTTYPE = {
    BUNDLE: 1,
    SELLABLEPRODUCT: 2,
  };
  public readonly PERMISSION_TYPE = {
    PERMISSION: 1,
    PERMISSION_GROUP: 2,
  };
  public readonly DOWNLOAD_WORKSHEET =
    Configuration.BaseUrlApi + "/cms/worksheet/download?";

  public readonly DOK = [
    { value: 1, label: "1. Recall", unavailable: false },
    { value: 2, label: "2. Skill/Concept", unavailable: false },
    { value: 3, label: "3. Strategic Thinking", unavailable: false },
    { value: 4, label: "4. Extended Thinking", unavailable: false },
  ];

  public readonly PASSAGETYPE = {
    READING: 1,
    NONREADING: 2,
  };
  public readonly ACADEMICSACTYVITYTYPE = {
    EDIT: 1,
    DELETE: 2,
  };
  public readonly UserRoleId = {
    SuperAdmin: 1,
    Employee: 2,
    Contractor: 3,
    District: 4,
    SchoolAdmin: 5,
    SchoolTeacher: 6,
    FreeTeacher: 7,
    PayTeacher: 8,
    Student: 9,
    Guardian: 12,
  };

  public readonly GradeLevelData = [
    {
      value: "ece",
      name: "Early Childhood Learning",
      label: "Early Childhood Learning (ece)",
    },
    { value: "elem", name: "Elementary", label: "Elementary (elem)" },
    { value: "ms", name: "Middle School", label: "Middle School (ms)" },
    { value: "hs", name: "High School", label: "High School (hs)" },
  ];
  public readonly UserErrorMessage = {
    FirstName: "Please enter first name",
    LastName: "Please enter last name",
    UserName: "Please enter username",
    Password: "Please enter password",
    Email: "Please enter email",
    Grade: "Please select grade",
    EmailFormat: "Please enter email in correct format",
    UsernameLength: "Username should be between 6 to 60 characters",
    PasswordLength: "Password should be between 6 to 60 characters",
    AssignmentCreateError: `There was an error processing your assignment.
    You can try again or reach out to our support team if you continue to experience problems at 1-877-377-9537.`,
  };
  public readonly TTS = {
    MIN_LENGTH_STORAGE_TTS: 3000,
    MAX_LENGTH_STORAGE_TTS: 10000,
  };
  public readonly MATHJAXCDN =
    "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML";
  public readonly Learnosity_Feature_Types = {
    Videoplayer: "videoplayer",
    Passage: "sharedpassage",
  };

  public readonly FROM_ASSOCIATE_STANDARD_KEY = "FROM_ASSOCIATE_STANDARD";

  public readonly PageMode = {
    EDIT: "EDIT",
    NEW: "NEW",
  };

  public readonly DEFULT_PAGINATION = {
    PAGE_NO_ONE: 1,
    PAGE_NO_TEN: 10,
  };

  public readonly CRM_TYPE = {
    USER: 1,
    SCHOOL: 2,
    DISTRICT: 3,
  };

  public readonly CANNED_TEST_EDIT_MODE = {
    DEFAULT: 0,
    PREMIUM_ASSESSMENT: 1,
  };

  public readonly CANNED_TEST_TYPE = {
    PRE_TEST: 1,
    POST_TEST: 2,
    CANNED_TEST: 3,
    PRACTICE_TEST: 4,
    DIGITAL_WORKSHEET: 5,
  };

  public readonly PastedImageErrors = {
    Question:
      "Question cannot be saved. Images must be added using the image upload button.",
    Passage:
      "Passage cannot be saved. Images must be added using the image upload button.",
  };

  public readonly LMS_TYPES = [
    { label: "Canvas", value: 1 },
    { label: "Google Classroom", value: 2 },
    { label: "Schoology", value: 3 },
  ];
}

export default new Constant();
